<template>

  <v-layout row>
    <v-list-tile
      slot="activator"
      @click.native="active"
    >
      <v-list-tile-avatar>
        <v-avatar size="32px" tile>
          <v-icon>add</v-icon>
        </v-avatar>
      </v-list-tile-avatar>
      <v-list-tile-title>Dodaj własny...</v-list-tile-title>
    </v-list-tile>
    <v-dialog v-model="dialog" max-width="500px">

      <v-card>
        <v-card-text>
          <v-form ref="setDefaultDrinkForm" v-model="formValid">
            <v-text-field
              label="Nazwa napoju"
              v-model="name"
              required
            ></v-text-field>
            <!--<v-text-field label="File name"></v-text-field>-->
            <!--<small class="grey&#45;&#45;text">* This doesn't actually save.</small>-->
            <v-text-field
              label="Pojemność napoju"
              v-model.number="size"
              :rules="[rules.required]"
              required
              type="number"
              min="0"
              max="100000"
            ></v-text-field>
            <!--<small class="grey&#45;&#45;text">* This doesn't actually save.</small>-->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="saveOwnDrink" :disabled="!formValid">Dodaj kubek</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!--<v-dialog v-model="dialog" transition="dialog-bottom-transition">-->
    <!--&lt;!&ndash;<v-btn color="primary" dark slot="activator">Open Dialog</v-btn>&ndash;&gt;-->
    <!--<v-list-tile-->
    <!--slot="activator"-->
    <!--@click.native.stop="dialog = !dialog"-->
    <!--&gt;-->
    <!--<v-list-tile-avatar>-->
    <!--<v-avatar size="32px" tile>-->
    <!--<v-icon>add</v-icon>-->
    <!--</v-avatar>-->
    <!--</v-list-tile-avatar>-->
    <!--<v-list-tile-title>Dodaj własny...</v-list-tile-title>-->
    <!--</v-list-tile>-->
    <!--<v-card>-->
    <!--<v-toolbar dark color="green">-->
    <!--<v-btn icon @click.native="dialog = false" dark>-->
    <!--<v-icon>close</v-icon>-->
    <!--</v-btn>-->
    <!--&lt;!&ndash;<v-toolbar-title class="text-xs-center">Kreator</v-toolbar-title>&ndash;&gt;-->
    <!--<v-spacer></v-spacer>-->
    <!--&lt;!&ndash;<v-toolbar-items right>&ndash;&gt;-->
    <!--<v-btn dark flat @click="saveOwnDrink">Zapisz</v-btn>-->
    <!--&lt;!&ndash;</v-toolbar-items>&ndash;&gt;-->
    <!--</v-toolbar>-->
    <!--<v-container grid-list-md>-->
    <!--<v-layout row wrap>-->
    <!--<v-flex xs12>-->
    <!--<v-text-field-->
    <!--label="Nazwa napoju"-->
    <!--v-model="name"-->
    <!--required-->
    <!--&gt;</v-text-field>-->
    <!--</v-flex>-->
    <!--<v-flex xs12>-->
    <!--<v-text-field-->
    <!--label="Pojemność napoju"-->
    <!--v-model="size"-->
    <!--required-->
    <!--&gt;</v-text-field>-->
    <!--</v-flex>-->
    <!--</v-layout>-->
    <!--</v-container>-->
    <!--&lt;!&ndash;<v-list three-line subheader>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-subheader>User Controls</v-subheader>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile avatar>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile-action>&ndash;&gt;-->

    <!--&lt;!&ndash;</v-list-tile-action>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile-content>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile-title>Nazwa napoju</v-list-tile-title>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile-sub-title>Nazwa napoju opisuje twój napój.</v-list-tile-sub-title>&ndash;&gt;-->
    <!--&lt;!&ndash;</v-list-tile-content>&ndash;&gt;-->
    <!--&lt;!&ndash;</v-list-tile>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile avatar>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile-action>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-text-field&ndash;&gt;-->
    <!--&lt;!&ndash;label="Pojemność"&ndash;&gt;-->
    <!--&lt;!&ndash;v-model="name"&ndash;&gt;-->
    <!--&lt;!&ndash;required&ndash;&gt;-->
    <!--&lt;!&ndash;&gt;</v-text-field>&ndash;&gt;-->
    <!--&lt;!&ndash;</v-list-tile-action>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile-content>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile-title>Pojemność kubka</v-list-tile-title>&ndash;&gt;-->
    <!--&lt;!&ndash;<v-list-tile-sub-title>Pojemność kubka definiuje ilość wypitego napoju.</v-list-tile-sub-title>&ndash;&gt;-->
    <!--&lt;!&ndash;</v-list-tile-content>&ndash;&gt;-->
    <!--&lt;!&ndash;</v-list-tile>&ndash;&gt;-->
    <!--&lt;!&ndash;</v-list>&ndash;&gt;-->
    <!--<v-divider></v-divider>-->
    <!--</v-card>-->
    <!--</v-dialog>-->
  </v-layout>

</template>

<script>

  export default {
    data() {
      return {
        dialog: false,
        size: 200,
        name: "",
        formValid: false,
        rules: {
          required: value => !!value || 'Niestety, to pole jest wymagane :(',
        }
      }
    },
    methods: {
      saveOwnDrink() {
        this.dialog = false;
        this.$emit('saveOwnDrink', {size: parseInt(this.size), name: this.name})
        this.addOwnDrinkSuccess();

      },
      active() {
        this.dialog = true;
        this.$emit('addOwnDrinkActive')
      },
      addOwnDrinkSuccess() {
        this.$emit('addOwnDrinkSuccess')

      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/otherComponents/addOwnDrink.vue